// Print button on the single-recipe page.
const printBtn = document.getElementById('print-recipe');
if (printBtn) {
  printBtn.addEventListener('click', () => window.print());
}
